import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  verifyModes: [],
  selectedVerifyMode: null,
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'name',
  sortDirection: 'asc',
  // Filtering
  filterName: '',
};

const verifyModesSlice = createSlice({
  name: 'verifyModes',
  initialState,
  reducers: {
    // Fetch verify modes
    fetchVerifyModes: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVerifyModesSuccess: (state, action) => {
      state.loading = false;
      state.verifyModes = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchVerifyModesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch verify mode by ID
    fetchVerifyModeById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVerifyModeByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedVerifyMode = action.payload;
      state.error = null;
    },
    fetchVerifyModeByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add verify mode
    addVerifyMode: (state) => {
      state.loading = true;
      state.error = null;
    },
    addVerifyModeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addVerifyModeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update verify mode
    updateVerifyMode: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateVerifyModeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.selectedVerifyMode = null;
      state.error = null;
    },
    updateVerifyModeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete verify mode
    deleteVerifyMode: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteVerifyModeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    deleteVerifyModeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete verify modes
    bulkDeleteVerifyModes: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteVerifyModesSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    bulkDeleteVerifyModesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchVerifyModes,
  fetchVerifyModesSuccess,
  fetchVerifyModesFailure,
  fetchVerifyModeById,
  fetchVerifyModeByIdSuccess,
  fetchVerifyModeByIdFailure,
  addVerifyMode,
  addVerifyModeSuccess,
  addVerifyModeFailure,
  updateVerifyMode,
  updateVerifyModeSuccess,
  updateVerifyModeFailure,
  deleteVerifyMode,
  deleteVerifyModeSuccess,
  deleteVerifyModeFailure,
  bulkDeleteVerifyModes,
  bulkDeleteVerifyModesSuccess,
  bulkDeleteVerifyModesFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterName,
  clearError,
  clearSuccessMessage,
} = verifyModesSlice.actions;

// Selectors
export const selectVerifyModes = (state) => state.verifyModes?.verifyModes || [];
export const selectSelectedVerifyMode = (state) => state.verifyModes?.selectedVerifyMode;
export const selectVerifyModesLoading = (state) => state.verifyModes?.loading || false;
export const selectVerifyModesError = (state) => state.verifyModes?.error;
export const selectVerifyModesSuccessMessage = (state) => state.verifyModes?.successMessage;
export const selectVerifyModesTotal = (state) => state.verifyModes?.total || 0;
export const selectVerifyModesPage = (state) => state.verifyModes?.page || 1;
export const selectVerifyModesPageSize = (state) => state.verifyModes?.pageSize || 10;
export const selectVerifyModesSortColumn = (state) => state.verifyModes?.sortColumn || 'name';
export const selectVerifyModesSortDirection = (state) => state.verifyModes?.sortDirection || 'asc';
export const selectVerifyModesFilterName = (state) => state.verifyModes?.filterName || '';

export default verifyModesSlice.reducer;
